import FeaturesTable from "@/components/pricing/FeaturesTable";
import { PlanCard, PURCHASE_PLANS } from "@/components/pricing/PlanCard";
import BasicBlock from "@/components/shared/basic-block";
import FAQ from "@/components/shared/FAQ";
import Footer from "@/components/shared/Footer";
import HeroSection from "@/components/shared/HeroSection";
import { NextSeo } from "next-seo";
import { useState } from "react";

const terms = ["monthly", "yearly"] as const;

const Pricing = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="flex size-full flex-col overflow-hidden bg-white transition-all duration-200 ease-in-out">
      <NextSeo
        title="Crayo AI | Viral clips in seconds."
        description="Your gateway to creating viral TikTok clips in seconds! Harness the power of AI to turn your ideas into captivating videos effortlessly."
      />
      <HeroSection
        heading={
          <h1 className="text-center text-5xl font-semibold text-gray-900 md:text-balance md:text-6xl md:tracking-[0.015em]">
            <span className="hidden lg:inline">Simple, transparent pricing</span>
            <span className="inline lg:hidden">Pricing</span>
          </h1>
        }
        body="Simple, but exceptionally powerful. Every feature you need now and as you reach millions of views."
        mobileBody="Every feature you need now and as you reach millions of views."
        wrapperStyle="py-14 lg:py-20"
      />
      <div className="flex w-full flex-col items-center justify-center space-y-32 lg:space-y-20">
        <BasicBlock contentStyle="flex-col gap-4" wrapperStyle="py-0">
          <div className="flex h-12 w-full rounded-lg bg-gray-100/50 p-1.5 md:mx-auto md:max-w-md">
            {terms.map((term, i) => (
              <button
                key={i}
                onClick={() => setActiveTab(i === activeTab ? (i === 0 ? 1 : 0) : i)}
                className={`relative flex-1 rounded-md text-sm font-medium transition-all duration-200 ${
                  activeTab === i ? "bg-white shadow-sm" : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {term.charAt(0).toUpperCase() + term.slice(1)}
                {i === 1 && <span className="text-sm italic text-gray-500">&nbsp;(save 20%)</span>}
              </button>
            ))}
          </div>
          <div className="w-full @container">
            <div className="grid grid-cols-1 gap-4 pt-0 @lg:grid-cols-3 @lg:pt-12">
              {PURCHASE_PLANS.map((plan, i) => (
                <PlanCard key={i} term={terms[activeTab]} plan={plan} />
              ))}
            </div>
          </div>
        </BasicBlock>
        <FeaturesTable plans={["Hobby", "Clipper", "Pro"]} />
        <FAQ />
        <Footer />
      </div>
    </div>
  );
};

export default Pricing;
